import React, { useReducer } from "react";
import { InputBase } from "@/components/ui/input-base";
import { Input } from "@/components/ui/input";
import { cn } from "@/utils/classnames";
import { DollarSign } from "lucide-react";

const CurrencyInput = React.forwardRef(
  ({ className, value, onChange, error, ...props }, ref) => {
    const handleChange = (e) => {
      onChange(e.target.value);
    };

    return (
      <div className="flex">
        <InputBase
          type="number"
          step="0.1"
          min="0.0"
          lang="en-US"
          value={value}
          onChange={handleChange}
          className={className}
          placeholder="20.70"
          siblingRight
          IconLeft={DollarSign}
          {...props}
        />
        <div className="bg-gray-100 rounded-r-lg border border-border px-3 border-l-0 flex items-center justify-center">
          <div className="text-gray-500 font-medium text-sm">USD</div>
        </div>
      </div>
    );
  }
);
CurrencyInput.displayName = "CurrencyInput";

const moneyFormatter = Intl.NumberFormat("en-US", {
  currency: "USD",
  currencyDisplay: "symbol",
  currencySign: "standard",
  style: "currency",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const CurrencyInputMasked = React.forwardRef(
  ({ className, value, onChange, error, ...props }, ref) => {
    const initialValue =
      value !== undefined ? moneyFormatter.format(value) : "";

    const [input, setInput] = useReducer((_, next) => {
      const digits = next.replace(/\D/g, "");
      const numberValue = digits ? Number(digits) : 0;
      return moneyFormatter.format(numberValue / 100);
    }, initialValue);

    function handleChange(realChangeFn, formattedValue) {
      const digits = formattedValue.replace(/\D/g, "");
      const realValue = digits ? Number(digits) / 100 : undefined;
      realChangeFn(realValue);
    }

    return (
      <div className="flex">
        <Input
          ref={ref}
          value={input}
          onChange={(ev) => {
            setInput(ev.target.value);
            handleChange(onChange, ev.target.value);
          }}
          className={cn(className)}
          {...props}
        />
      </div>
    );
  }
);
CurrencyInputMasked.displayName = "CurrencyInputMasked";

export { CurrencyInput, CurrencyInputMasked };
